import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css';

import route from './router';
import store from '../store/index';
import getPageTitle from '../util/get-page-title';
import Constant from '@/lib/constant';

const { openWarnPath } = Constant;
NProgress.configure({ showSpinner: false }); // NProgress Configuration

route.beforeEach(async (to, from, next) => {
  NProgress.start();
  // 记录登录前页面的path
  if (from.fullPath != '/') {
    sessionStorage.setItem('router_from', from.fullPath);
  }
  // 设置title
  document.title = getPageTitle(to.meta.title);
  // 埋点pv
  if (to.meta && to.meta.trackId && Telescope) {
    Telescope.trackPage({ trackId: to.meta.trackId });
  }
  if (to.path === '/login') {
    // 如果目标页面是登录页 直接跳转
    next();
    NProgress.done();
  } else {
    // 如果目标页面是其他页面
    const hasRoles = store.getters.getRoles && store.getters.getRoles.length > 0;
    if (hasRoles) {
      // 有用户身份直接进入
      // 页面切换更新用户信息
      if (openWarnPath.some(v => v == to.path)) {
        // 重开警告框的逻辑
        // store.dispatch('messageCenter/GetmessageCenterNotification');
        store.commit('global/SETwarnState', 1);
      }
      console.log('hasRoles', to);

      if (to.matched.length > 0) {
        next();
      } else {
        const defaultRoute = store.state.permission.addRoutes.find(o => o.meta && !o.meta?.hide);

        next({
          path: defaultRoute?.path,
          replace: true
        });
      }
    } else {
      // 缺少用户权限 首先去获取用户权限
      try {
        // store.dispatch('messageCenter/GetmessageCenterNotification');
        const { roles, userInfo } = await store.dispatch('permission/getInfo');
        let data;
        Telescope.login({ uid: userInfo?.ucUserId });
        try {
          data = await Fetch.isShowB2BEntry();
        } catch (err) {
          console.log('b2b 入口接口报错', err);
        }

        let supervisionConfig;

        try {
          supervisionConfig = await Fetch.check_amikacin_store();
        } catch (err) {
          console.log('药监销售订单 入口接口报错', err);
        }

        const accessRoutes = await store.dispatch('permission/GenerateRoutes', {
          roles,
          userInfo,
          drugShopEntrance: data?.drugShopEntrance,
          supervisionConfig
        });
        route.addRoutes(accessRoutes);
        // 修复原因：
        // 之前用 accessRoutes.some(o => o.path == to.path) 只会比较“顶层路由 path”，
        // 对 /prescription/detail/:id 这类子路由在刷新场景会误判为不存在，从而被重定向到默认页。
        // 解决方法：
        // 动态 addRoutes 后，改为用 router.match(to.path) 判断“最终是否可匹配到任意路由记录”。
        // 只要 matched.length > 0，就放行到目标页；否则才回退默认路由。
        const targetMatchedAfterAdd = route.match(to.path).matched;
        const canAccessTarget = targetMatchedAfterAdd && targetMatchedAfterAdd.length > 0;
        if (canAccessTarget) {
          next({ ...to, replace: true });
        } else {
          const defaultRoute = accessRoutes.find(o => o.meta && !o.meta?.hide);

          next({
            path: defaultRoute?.path,
            replace: true
          });
        }
      } catch (error) {
        console.log(error);
        console.log('出错');
        next();
      }
    }
  }
});
route.afterEach(() => {
  // eslint-disable-next-line no-unused-expressions
  window?.webVitals?.zyCustomContentfulPaint();
  NProgress.done(); // finish progress bar
});
export default route;
